import { __awaiter, __generator } from "tslib";
import { url } from '../../_core/url';
import { getThreadId } from "../../domain/selectors/get-thread-id";
import { startChat } from "./start-chat";
/**
 * If there is no active conversation, do nothing. Otherwise, start a new conversation.
 */
export var continueChat = function (history) { return function (dispatch, getState) { return __awaiter(void 0, void 0, void 0, function () {
    var isOnStartPage, state, currentThreadId;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                isOnStartPage = history.location.pathname === url.CHAT_START();
                state = getState();
                currentThreadId = getThreadId(state);
                if (!(!currentThreadId || isOnStartPage)) return [3 /*break*/, 2];
                return [4 /*yield*/, dispatch(startChat(history))];
            case 1:
                _a.sent();
                return [3 /*break*/, 2];
            case 2: return [2 /*return*/];
        }
    });
}); }; };
